export const getDateObject = (endDate?: string, monthSupported?: boolean) => {
  if (!endDate) {
    return new Date();
  }
  if (monthSupported) {
    return new Date(endDate);
  }
  const dateParts = endDate!.toString().split("/");
  return new Date(`${dateParts[1]}-${dateParts[0]}-01`);
};
